import conf from '../conf'

function globalError(xhr) {
  if(  xhr.status == 401 && xhr.responseJSON && (xhr.responseJSON.error_description.indexOf('expire') != -1 || xhr.responseJSON.error_description.indexOf('token') != -1) ){
    sessionStorage.removeItem('accessToken')
    document.location.href =  '/login?backUrl='+encodeURIComponent(location.href)
  }
}



const io = {


  configUrls: function () {

    const basePath = conf.baseApiPath + '/yyfn-api'
    this.apiUploadToken = basePath.replace('/api/m/t/', '') + '/api/qiniu/upload/token'

    this.getAreaTeams = basePath + '/api/m/areaTeams'

    // this.apiConfig = basePath + '/config'
    this.generatePictureCaptcha = basePath + '/api/m/generatePictureCaptcha'
    this.checkNeedCaptcha = basePath + '/api/m/checkNeedCaptcha'
    this.login = basePath + '/api/m/login'
    this.apiWXLogin = basePath + '/api/m/wx/login'
    this.bindPhoneNo = basePath + '/api/m/wx/bindPhoneNo'
    this.apiConfig = basePath + '/api/m/config'
    this.unbindPhoneNo = basePath + '/api/m/wx/unbindPhoneNo'
    // 首页
    this.carousel = basePath + '/api/m/findConfigByCond'
    this.recommendCourse = basePath + '/api/m/suggestCourseClass'
    this.recommendTeacher = basePath + '/api/m/teachers'
    this.courseSearchCondition = basePath + '/api/m/courseSearchCondition'
    this.teacherOfCourseFilterCondConfig = basePath + '/api/m/teacherOfCourseFilterCondConfig'

    this.advertBanner = basePath + '/api/m/ad'
    this.courseFilterCondConfig = basePath + '/api/m/courseFilterCondConfig'
    this.outCourseClassList = basePath + '/api/m/outCourseClassList'

    // 教师详情页
    this.teacherDetail = basePath + '/api/m/teacherDetail'

    // 课程详情
    this.getDetails = basePath + '/api/m/outCourseClass'
    this.classLectures = basePath + '/api/m/classLectures'
    this.campusDetail = basePath + '/api/m/campusDetail'
    this.addToCart = basePath + '/api/m/u/addToShoppingCart'
    this.suggestCourseClassForDetailPage = basePath + '/api/m/suggestCourseClassForDetailPage'
    // this.createOneOuter = basePath + '/api/m/createOneOuterOrder'
    // 联系我们
    this.contact = basePath + '/api/m/u/contactUs'
    // 收藏
    this.myCollection = basePath + '/api/m/u/findOuterCollection'
    // 订单
    this.order = basePath + '/api/m/u/findOuterOrder'
    this.cancelOuterOrder = basePath + '/api/m/u/cancelOuterOrder'
    //个人信息
    // this.personal = basePath + '/api/m/u/personMessage'
    this.findBindStudentDetail = basePath + '/api/m/u/findBindStudentDetail'
    this.searchSchool = basePath + '/api/m/searchSchool'
    this.updateBindStudentInfo = basePath + '/api/m/u/updateBindStudentInfo'
    //听课证
    this.courseRegistrationCard = basePath + '/api/m/u/courseRegistrationCard'
    //查询课程
    this.mineCourse = basePath + '/api/m/u/findOuterCourseClass'
    this.teacher = basePath + '/api/m/teachers'
    this.campus = basePath + '/api/m/findCampusCond'
    this.hotSearch = basePath + '/api/m/hotSearch'
    //添加收藏
    this.addOuter = basePath + '/api/m/u/addOuterCollection'
    //取消收藏
    this.deleteOuter = basePath + '/api/m/u/deleteOuterCollection'
    this.list = basePath + '/api/m/u/shoppingCartList'
    // 个辅课程列表
    this.studentVipRegs = basePath + '/api/m/u/studentVipRegs'
    // 个辅查看课表
    this.queryVipRegClasses = basePath + '/api/m/u/queryVipRegClasses'


    this.addNewStudent = basePath + '/api/m/u/addNewStudentAndBind'
    //课程列表
    this.deleteCart = basePath + '/api/m/u/deleteShoppingCart'
    this.updateStudentToCart = basePath + '/api/m/u/updateShoppingCartStudent'
    this.createCartOrder = basePath + '/api/m/u/createOuterOrders'
    this.degreeSubscribe = basePath + '/api/m/u/degreeSubscribe'
    // 购物车结算
    this.cartNum = basePath + '/api/m/u/cartNum'
    //订单支付
    this.payOuter = basePath + '/api/m/u/payOuterOrder'
    this.findOrder = basePath + '/api/m/findOneOuterOrder'
    this.orderDiscountDesc = basePath + '/api/m/orderDiscountDesc'
    this.createOrder = basePath + '/api/pay/preparePay'
    this.createBookingOuterOrder = basePath + '/api/m/u/createBookingOuterOrder'
    this.checkOrderCourseStatus = basePath + '/api/m/checkOrderCourseStatus'
    this.confirmPayForOnlyBalance = basePath + '/api/m/confirmPayForOnlyBalance'
    this.queryDiscountCode = basePath + '/api/m/queryDiscountCode'
    this.addDiscount = basePath + '/api/m/addDiscount'
    //更改个人信息
    this.updatePersonMessage = basePath + '/api/m/u/updatePersonMessage'
    this.getCityByL2 = basePath + '/api/m/positionNameByLngAndLat'
    this.getL2ByCity = basePath + '/api/m/lngAndLatByPositionName'
    this.getNearbyCompus = basePath + '/api/m/findCampusByPosition'
    this.changePhoneNo = basePath + '/api/m/u/changePhoneNo'
    this.createOneOrder = basePath + '/api/m/u/createOneOuterOrder'
    this.sendCode = basePath + '/api/sms/sendCode'
    this.solutionStudent = basePath + '/api/m/u/solutionStudent'

    //我的课表
    this.schedule = basePath + '/api/m/u/schedule'
    //服务
    this.getPeriod = basePath + '/api/m/periodConfig'
    this.homeworkList = basePath + '/api/m/homeworkCourseClass'
    this.lectureList = basePath + '/api/m/homeworkListOfLecture'
    this.homeworkContent = basePath + '/api/m/homeworkContent'
    this.attendance = basePath + '/api/m/attendanceCourseClass'
    this.attendanceDetail = basePath + '/api/m/attendanceDetailListOfLecture'
    this.getClassByHomeworkId = basePath + '/api/m/courseClassForHomework'
    this.findCampusByAreaTeamId = basePath + '/api/m/findCampusByAreaTeamId'
    //名师风采
    this.raiseTeacher = basePath + '/api/m/raiseTeacher'
    this.gradeAndSubjectList = basePath + '/api/m/gradeAndSubjectList'
    this.raiseClassDetail = basePath + '/api/m/raiseClassDetail'

    this.cityList = basePath + '/api/m/cityList'
    //推荐
    this.suggestContinueClass = basePath + '/api/m/suggestContinueClass'
    this.calDiscount = basePath + '/api/m/u/calDiscount'
    // 测评
    this.onlineTestList = basePath + '/api/m/onlineTestList'
    this.beginTesting = basePath + '/api/m/beginTesting'
    this.saveTestResult = basePath + '/api/m/saveTestResult'
    this.onlineTestResult = basePath + '/api/m/onlineTestResult'
    this.saveExternalScore = basePath + '/api/m/saveExternalScore'
    // 调班
    this.availableShiftInCourseClasses = basePath + '/api/m/availableShiftInCourseClasses'
    this.availableShiftOutCourseClasses = basePath + '/api/m/availableShiftOutCourseClasses'
    this.confirmShiftClass = basePath + '/api/m/confirmShiftClass'
    this.classLectureOfStudent = basePath + '/api/m/classLectureOfStudent'
    this.campusOfAreaTeam = basePath + '/api/m/campusOfAreaTeam'
    this.checkCanShift = basePath + '/api/m/checkCanShift'
    this.canChangeClassList = basePath + '/api/m/u/canChangeClassList'
    this.turnClass = basePath + '/api/m/u/turnClass'
    // 一键加入购物车
    this.queryShareItems = basePath + '/api/m/queryShareItems'
    this.addToShoppingCartByQrCode = basePath + '/api/m/u/addToShoppingCartByQrCode'
    this.queryCourseClassesByIds = basePath + '/api/m/u/queryCourseClassesByIds'

    //余额
    this.studentBalance = basePath + '/api/m/u/studentBalance'
    this.rechargeBalance = basePath + '/api/m/u/rechargeBalance'
    this.refreshOuterOrderBalancePays = basePath + '/api/m/u/refreshOuterOrderBalancePays'
    // 购物车查询提示语
    this.checkRegAvailable = basePath + '/api/m/checkRegAvailable'

    this.addOrderMarketTracking = basePath + '/api/m/u/addOrderMarketTracking'
    this.upload = basePath + '/api/cos/upload'

    // 拼团
    const groupBasePath = conf.baseApiPath + '/mc-api'

    this.queryGroupActivity = groupBasePath + '/api/m/queryGroupActivity'
    this.inProgressGroups = groupBasePath +  '/api/m/inProgressGroups'
    this.createGroupOrder = groupBasePath +  '/api/m/u/createGroupOrder'
    this.groupOrder = groupBasePath +  '/api/m/groupOrder'
    this.ordersOfCurrentUser = groupBasePath +  '/api/m/u/ordersOfCurrentUser'
    this.group = groupBasePath +  '/api/m/group'
    
    // 优惠券   
    this.getCouponActivity = groupBasePath +  '/api/m/getCouponActivity'
    this.isReleaseCoupon = groupBasePath +  '/api/m/isReleaseCoupon'
    this.releaseCoupon = groupBasePath +  '/api/m/u/releaseCoupon'
    this.myShareRecord = groupBasePath +  '/api/m/myShareRecord'
    this.logBack = groupBasePath +  '/api/m/logBack'
    this.shareCoupon = groupBasePath +  '/api/m/shareCoupon'

    this.queryMyCoupons = basePath +  '/api/m/u/queryMyCoupons'
    this.queryCandidateCoupon = basePath +  '/api/m/u/queryCandidateCoupon'
    
    //测评预约
    this.testSubscribe =  basePath + '/api/m/u/testSubscribe'


  },
  getHeaders: function (url) {
    if (url.indexOf('/api/m/u') != -1) {
      return {
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      }
    } else if(url.indexOf('uc-api') != -1 && url.indexOf('/u/') != -1){
      return {
        'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
      }
    } else {
      return {}
    }

  },
  get: function (url, data, success, fail) {
    $.ajax({
      url: url,
      type: 'GET',
      data: data,
      dataType: 'json',
      cache: true,
      timeout: 30000,
      headers: this.getHeaders(url),
      success: function (data) {
        if (success) {
          success(data);
        }
      },
      error: function (xhr, status, error) {
        if (fail) {
          fail(xhr, status, error);
        } else {
          //alert("服务端出错");
        }
      }
    });
  },
  post: function (url, data, success, fail) {
    $.ajax({
      url: url,
      type: 'POST',
      data: data,
      dataType: 'json',
      timeout: 30000,
      headers: this.getHeaders(url),
      success: function (data) {
        if (success) {
          success(data);
        }
      },
      error: function (xhr, status, error) {
        globalError(xhr)
        if (fail) {
          fail(xhr, status, error);
        } else {
          //alert("服务端出错");
        }
      }
    });
  },
  syncPost: function (url, data, success, fail) {
    $.ajax({
      url: url,
      type: 'POST',
      data: data,
      dataType: 'json',
      timeout: 30000,
      async: false,
      headers: this.getHeaders(url),
      success: function (data) {
        if (success) {
          success(data);
        }
      },
      error: function (xhr, status, error) {
        globalError(xhr)
        if (fail) {
          fail(xhr, status, error);
        } else {
          //alert("服务端出错");
        }
      }
    });
  },
  postPlayload: function (url, data, success, fail) {
    $.ajax({
      url: url,
      type: 'POST',
      contentType: 'application/json; charset=UTF-8',
      data: JSON.stringify(data),
      dataType: 'json',
      processData: false,
      timeout: 30000,
      headers: this.getHeaders(url),
      success: function (data) {
        if (success) {
          success(data);
        }
      },
      error: function (xhr, status, error) {
        globalError(xhr)
        if (fail) {
          fail(xhr, status, error);
        } else {
          //alert("服务端出错");
        }
      }
    });
  },
  getCity: function () {
    var city = localStorage.getItem('city');
    var currentCity = sessionStorage.getItem('city');
    return city ? city : (currentCity ? currentCity : '广州')
  }

};

io.configUrls()

export default io;



// WEBPACK FOOTER //
// ./src/lib/io/index.js